import { useQuery } from 'react-query';
import axios from '../axios';
import Cookies from 'universal-cookie';
import { get } from 'lodash-es';
import { login } from '../../store';
import jwt_decode from 'jwt-decode';
import { isEmpty } from 'lodash';
const cookies = new Cookies();

/**
 * Fetches the users profile information
 * @returns {{}} User object
 */
export function useWhoAmI() {
  return useQuery('customer/whoAmI', () =>
    axios.get('/users/whoAmI').then((res) => {
      var response = null;
      const user = {
        ...res.data.user,
        IS_CORPORATE_ADMIN: !isEmpty(res.data?.user?.corporate),
      };
      response = res.data;
      response.user = user;
      return response;
    }),
  );
}

export const updateUserInfo = async (updateValues) => {
  console.log(cookies.get('jp_refreshtoken'));
  return axios
    .post(`/users/updateProfile`, updateValues, {
      headers: {
        refreshToken: cookies.get('jp_refreshtoken'),
      },
    })
    .then((res) => {
      cookies.remove('jp_idtoken');
      cookies.remove('jp_refreshtoken');
      cookies.remove('jp_accesstoken');
      cookies.set('jp_idtoken', get(res, 'data.idToken'), {
        path: '/',
      });
      cookies.set('jp_refreshtoken', get(res, 'data.refreshToken'), {
        path: '/',
      });
      cookies.set('jp_accesstoken', get(res, 'data.accessToken'), {
        path: '/',
      });
      login(jwt_decode(get(res, 'data.idToken')));
      return res.data;
    });
};

export const verifyOTP = async ({ otp, verificationAttribute }) => {
  return axios
    .post(
      '/users/profileVerification',
      {
        code: otp,
        attributes: [verificationAttribute],
      },
      {
        headers: {
          refreshToken: cookies.get('jp_refreshtoken'),
          accessToken: cookies.get('jp_accesstoken'),
        },
      },
    )
    .then((res) => {
      cookies.remove('jp_idtoken');
      cookies.remove('jp_refreshtoken');
      cookies.remove('jp_accesstoken');
      cookies.set('jp_idtoken', get(res, 'data.idToken'), {
        path: '/',
      });
      cookies.set('jp_refreshtoken', get(res, 'data.refreshToken'), {
        path: '/',
      });
      cookies.set('jp_accesstoken', get(res, 'data.accessToken'), {
        path: '/',
      });
      login(jwt_decode(get(res, 'data.idToken')));
      return res.data;
    });
};

export const resendOTP = async (request) => {
  return axios
    .post('/users/reSendAttributeVerificationOtp', request, {
      headers: {
        refreshToken: cookies.get('jp_refreshtoken'),
        accessToken: cookies.get('jp_accesstoken'),
      },
    })
    .then((res) => {
      return res.data;
    });
};
